import { Button, Grid, Menu, MenuItem, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Delete, MoreVert } from '@material-ui/icons';
import EditIcon from '../../assets/SvgIonReorderTwo';
import { formateDate, sortItemsBySelection } from '../utils/Utils';
import Image from '../common/Image';

const useStyle = makeStyles({
  collectionCard: {
    background: '#f3f4f7',
    padding: '10px',
    width: '95%',
    borderRadius: '10px',
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },
  collectionWrapper: {
    display: 'flex',
    gap: '10px',
    width: '95%',
  },
  collectionImg: {
    height: '80px',
    width: '55px',
  },
  jouneyContent: {
    width: '100%',
  },
  jouneyTitle: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  collectionDate: {
    fontSize: '12px',
  },
  equlaIcon: {
    fontSize: '18px',
  },
  journesContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '10px',
  },
  journesWrapper: {
    width: '100%',
    height: '550px',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  newCollectionCard: {
    background: '#f3f4f7',
    padding: '10px',
    width: '97%',
    borderRadius: '10px',
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },
  addNewCollection: {
    display: 'flex',
    gap: '10px',
    width: '95%',
  },
  searchBox: {
    width: '100%',
  },
  searchField: {
    width: '96%',
    padding: '10px',
  },
  actionBtns: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    justifyContent: 'flex-end',
  },
  cancelBtn: {
    border: '1px solid gray',
    cursor: 'pointer',
    height: '40px',
    width: '80px',
    borderRadius: '4px',
  },
  addBtn: {
    cursor: 'pointer',
    height: '40px',
    width: '75px',
    borderRadius: '4px',
  },
  checkbox: {
    width: '18px',
    height: '18px',
  },
});

export default function CollectionCard({ collectionData, setAnchorEl, setSelectedId }) {
  const classes = useStyle();

  const handleClick = (event, CollectionId) => {
    setAnchorEl(event.currentTarget);
    setSelectedId(CollectionId);
  };

  return (
    <div className={classes.collectionCard}>
      <p className={classes.equlaIcon}>
        <EditIcon />
      </p>
      <Grid className={classes.collectionWrapper}>
        <Image className={classes.collectionImg} src={collectionData.thumbnail} alt="Collection Pic" />
        <Grid className={classes.jouneyContent}>
          <Grid className={classes.jouneyTitle}>
            <Typography>{collectionData.title}</Typography>
            <div>
              <MoreVert onClick={(e) => handleClick(e, collectionData.id)} style={{ cursor: 'pointer' }} />
            </div>
          </Grid>

          <Typography variant="p" className={classes.collectionDate}>
            {formateDate(collectionData.publishDate)}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
}

export function MenuItems({ anchorEl, setAnchorEl, onDelete }) {
  return (
    <Menu
      id="simple-menu"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={() => setAnchorEl(null)}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <MenuItem style={{ justifyContent: 'left' }} onClick={onDelete}>
        <Delete /> Remove Collection
      </MenuItem>
    </Menu>
  );
}

export function AllCollectionsList({
  handleSelectCollection,
  selectedCollections,
  setSelectedCollections,
  handleUpdateCollection,
  setIsOpenModal,
  filteredCollections,
  setFilteredCollections,
  collections,
}) {
  const classes = useStyle();
  const [searchValue, setSearchValue] = useState('');
  const [temp] = useState(selectedCollections);

  // Selected list should move up in the list
  const sortedCollections = sortItemsBySelection(selectedCollections, filteredCollections, 'id');

  useEffect(() => {
    if (searchValue) {
      const filtered = collections.filter((collection) =>
        collection.title.toLowerCase().includes(searchValue.toLowerCase()),
      );
      setFilteredCollections(filtered);
    } else {
      setFilteredCollections(collections);
    }
  }, [searchValue, collections]);

  return (
    <Grid container className={classes.journesContainer}>
      <Grid>
        <Typography>Add New Collections</Typography>
      </Grid>
      <Grid className={classes.searchBox}>
        <input
          className={classes.searchField}
          type="text"
          placeholder="Search Collection"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
      </Grid>
      <Grid className={classes.journesWrapper}>
        {sortedCollections?.map((data) => (
          <Grid className={classes.newCollectionCard} key={data.id}>
            <p className={classes.equlaIcon}>
              <input
                type="checkbox"
                onChange={() => handleSelectCollection(data.id)}
                checked={selectedCollections.includes(data.id)}
                className={classes.checkbox}
              />
            </p>
            <Grid className={classes.addNewCollection}>
              <Image className={classes.collectionImg} src={data.thumbnail} alt="Collection Pic" />
              <Grid className={classes.jouneyContent}>
                <Grid className={classes.jouneyTitle}>
                  <Typography> {data.title} </Typography>
                </Grid>
                <Typography variant="p" className={classes.collectionDate}>
                  {formateDate(data?.publishDate)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
      <Grid className={classes.actionBtns}>
        <Button
          onClick={() => {
            setSelectedCollections(temp);
            setIsOpenModal(false);
          }}
          className={classes.cancelBtn}
        >
          Cancel
        </Button>
        <Button
          className={classes.addBtn}
          color="primary"
          variant="contained"
          onClick={() => handleUpdateCollection(selectedCollections)}
        >
          Add
        </Button>
      </Grid>
    </Grid>
  );
}
